'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.classList = classList;
function classList() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    var list = [].concat(args);
    list.toString = function () {
        return list.join(' ');
    };
    return list;
}

exports.default = classList;


//////////////////
// WEBPACK FOOTER
// ./~/ereader-core/dist/classList.js
// module id = 19
// module chunks = 0